import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { GET_CURRENCY_CONFIG } from "../../redux/actions/constants";
import {
    getChartSettingsAction,
    updateSettingsAction
} from "../../redux/actions/currenciesActions";
import { updateChartDefaults } from "../../services/rashTradeServices";
import { strategies } from "../../staticData/strategies";
import Calendar from "../../utils/calendar/Calendar";
import FillDataInputComponent from "../../utils/FillDataInput";
import { errorToastify, successToastify } from "../../utils/Toastify";
import FieldSetComponent from "../common-components/Fieldset";
import Spinner from "../common-components/Spinner";
import StartStopbtn from "../common-components/StartStopbtn";
import TradeBoxes from "../common-components/TradeBoxes";
import MainBoxHeader from "../MainBoxHeader";

export default function ChartsDataConfig({ toggleModal }) {
    const { currentCurrencyId, currentSide, currenciesList, spinnerStatus, isDarkMode } =
        useSelector(
            (state) => state.persistedReducer,
            (oldValue, newValue) => {
                if (
                    oldValue.isDarkMode !== newValue.isDarkMode ||
                    oldValue.spinnerStatus !== newValue.spinnerStatus ||
                    newValue.currentCurrencyId !== oldValue.currentCurrencyId ||
                    oldValue.currentSide !== newValue.currentSide
                ) {
                    return false;
                }
                return true;
            }
        );
    const {
        waveLevels: { buyWave, sellWave }
    } = currenciesList[currentCurrencyId];
    const {
        currencyConfigs: {
            strategyType,
            renkoPipes,
            timeFrame: timeFrameValue,
            distanceMoving: distance_moving,
            startRenko: startRenkoValue,
            upperBoundRangePercentage,
            lowerBoundRangePercentage,
            emaValueFastRenko,
            emaValueSlowRenko,
            mastep1,
            mastep2,
            mastep3,
            mastep4,
            mastep5,
            waveEma1,
            waveEma2
        }
    } = currenciesList[currentCurrencyId][currentSide.side];
    const dispatch = useDispatch();
    const [state, setState] = useState({
        renkoSize: {
            placeholder: "renko Size",
            value: renkoPipes
        },
        timeFrame: {
            placeholder: "Select Time Frame",
            value: timeFrameValue
        },
        strategy: {
            placeholder: "Select Strategy",
            value: strategyType,
            selectType: "StrSelectInput"
        },
        renkoNumber: {
            placeholder: "Renko Number",
            value: ""
        },
        distanceMoving: {
            placeholder: "Moving Average Distance",
            value: distance_moving
        },
        upperBRP: {
            placeholder: "Number of Renko",
            value: upperBoundRangePercentage
        },
        lowerBRP: {
            placeholder: "Stoploss Activation Percentage",
            value: lowerBoundRangePercentage
        },
        startRenko: {
            placeholder: "Start Renko",
            value: startRenkoValue
        },
        // slingShotFastCandle: {
        //     placeholder: "Slingshot Fast",
        //     value: ""
        // },
        // slingShotSlowCandle: {
        //     placeholder: "Slingshot Slow",
        //     value: ""
        // },
        slingShotFastRenko: {
            placeholder: "Slingshot Fast",
            value: emaValueFastRenko
        },
        slingShotSlowRenko: {
            placeholder: "Slingshot Slow",
            value: emaValueSlowRenko
        },
        movingaverage1: {
            placeholder: "movingaverage1",
            value: mastep1
        },
        movingaverage2: {
            placeholder: "movingaverage2",
            value: mastep2
        },
        movingaverage3: {
            placeholder: "movingaverage3",
            value: mastep3
        },
        movingaverage4: {
            placeholder: "movingaverage4",
            value: mastep4
        },
        movingaverage5: {
            placeholder: "movingaverage5",
            value: mastep5
        },
        manRateDown: {
            placeholder: "Down",
            value: waveEma1
        },
        manRateUp: {
            placeholder: "up",
            value: waveEma2
        },
        sideWaveLevelBuy: {
            placeholder: `Wave Level Buy`,
            value: buyWave
        },
        sideWaveLevelSell: {
            placeholder: `Wave Level Sell`,
            value: sellWave
        }
    });

    const {
        distanceMoving,
        manRateDown,
        manRateUp,
        movingaverage1,
        movingaverage2,
        movingaverage3,
        movingaverage4,
        movingaverage5,
        renkoNumber,
        renkoSize,
        slingShotFastCandle,
        slingShotFastRenko,
        slingShotSlowCandle,
        lowerBRP,
        upperBRP,
        slingShotSlowRenko,
        startRenko,
        strategy,
        timeFrame,
        sideWaveLevelBuy,
        sideWaveLevelSell
    } = state;

    const updatedValuesObject = {
        strategy,
        renkoSize,
        timeFrame,
        // renkoNumber,
        // slingShotFastCandle,
        // slingShotSlowCandle,
        distanceMoving,
        upperBRP,
        lowerBRP,
        slingShotFastRenko,
        slingShotSlowRenko,
        movingaverage1,
        movingaverage2,
        movingaverage3,
        movingaverage4,
        movingaverage5,
        manRateDown,
        manRateUp,
        sideWaveLevelBuy,
        sideWaveLevelSell
    };

    let inputsSection = [
        {
            headerName: "Date, Renko size & Time frame",
            FieldSet: [
                {
                    legend: "Strategy",
                    // columnSpan: "2/3",
                    // rowSpan: "1/2",
                    classNames: {
                        legendClassName: "  text-[#000]  block p-1 text-base",
                        fieldsetClassName:
                            "flex flex-wrap justify-around items-center primaryBorder rounded-sm"
                    },
                    styles: {
                        legendStyle: {},
                        fieldsetStyle: {}
                    },
                    FillDataInput: [
                        {
                            inputType: "Select",
                            className: "flex justify-start w-full z-100",
                            inputValue: strategy,
                            optionsList: strategies,
                            optionName: "strategy_desc",
                            defaultText: strategy.placeholder
                                ? strategy.placeholder
                                : "Select Strategy",
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    strategy: {
                                        ...prev.strategy,
                                        placeholder: strategies[value.row_id].strategy_desc,
                                        value: value.row_id
                                    }
                                }))
                        }
                    ]
                },
                {
                    legend: "Renko & Time Frame",
                    classNames: {
                        legendClassName: " text-[#000]  block p-1 text-base",
                        fieldsetClassName:
                            "flex flex-wrap justify-around items-center primaryBorder rounded-sm"
                    },
                    styles: {
                        legendStyle: {},
                        fieldsetStyle: {}
                    },
                    FillDataInput: [
                        {
                            inputType: "Text",
                            className: "",
                            inputValue: renkoSize,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    renkoSize: {
                                        ...prev.renkoSize,
                                        value
                                    }
                                }))
                        },
                        {
                            inputType: "Text",
                            className: "",
                            inputValue: timeFrame,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    timeFrame: {
                                        ...prev.timeFrame,
                                        value
                                    }
                                }))
                        }
                    ]
                },
                {
                    legend: "Fuzzy Touch & Start Renko",
                    classNames: {
                        legendClassName: " text-[#000]  block p-1 text-base",
                        fieldsetClassName:
                            "flex flex-wrap justify-around items-center primaryBorder rounded-sm"
                    },
                    styles: {
                        legendStyle: {},
                        fieldsetStyle: {}
                    },
                    FillDataInput: [
                        {
                            inputType: "Text",
                            className: "",
                            inputValue: distanceMoving,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    distanceMoving: {
                                        ...prev.distanceMoving,
                                        value
                                    }
                                }))
                        },
                        {
                            inputType: "Text",
                            className: "",
                            inputValue: startRenko,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    startRenko: {
                                        ...prev.startRenko,
                                        value
                                    }
                                }))
                        }
                    ]
                }
            ]
        },
        {
            headerName: "Dynamic Stoploss",
            FieldSet: [
                {
                    legend: "Renko & Percentage",
                    // columnSpan: "2/3",
                    // rowSpan: "1/2",
                    classNames: {
                        legendClassName: " text-[#000]  block p-1 text-base",
                        fieldsetClassName:
                            "flex flex-wrap justify-around items-center primaryBorder rounded-sm"
                    },
                    styles: {
                        legendStyle: {},
                        fieldsetStyle: {}
                    },
                    FillDataInput: [
                        {
                            inputType: "Text",
                            className: "",
                            inputValue: upperBRP,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    upperBRP: {
                                        ...prev.upperBRP,
                                        value
                                    }
                                }))
                        },
                        {
                            inputType: "Text",
                            className: "",
                            inputValue: lowerBRP,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    lowerBRP: {
                                        ...prev.lowerBRP,
                                        value
                                    }
                                }))
                        }
                    ]
                }
            ]
        },
        {
            headerName: "Slingshots",
            FieldSet: [
                {
                    legend: "Renko Based",
                    // columnSpan: "2/3",
                    // rowSpan: "1/2",
                    classNames: {
                        legendClassName: " text-[#000]  block p-1 text-base",
                        fieldsetClassName:
                            "flex flex-wrap justify-around items-center primaryBorder rounded-sm"
                    },
                    styles: {
                        legendStyle: {},
                        fieldsetStyle: {}
                    },
                    FillDataInput: [
                        {
                            inputType: "Text",
                            className: "",
                            inputValue: slingShotFastRenko,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    slingShotFastRenko: {
                                        ...prev.slingShotFastRenko,
                                        value
                                    }
                                }))
                        },
                        {
                            inputType: "Text",
                            className: "",
                            inputValue: slingShotSlowRenko,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    slingShotSlowRenko: {
                                        ...prev.slingShotSlowRenko,
                                        value
                                    }
                                }))
                        }
                    ]
                }
            ]
        },
        {
            headerName: "Moving Average",
            FieldSet: [
                {
                    legend: "Moving Average",
                    classNames: {
                        legendClassName: " text-[#000]  block p-1 text-base",
                        fieldsetClassName:
                            "flex flex-wrap justify-around items-center primaryBorder rounded-sm"
                    },
                    styles: {
                        legendStyle: {},
                        fieldsetStyle: {}
                    },
                    FillDataInput: [
                        {
                            inputType: "Text",
                            className: "trade_inputs_movingaverage",
                            inputValue: movingaverage1,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    movingaverage1: {
                                        ...prev.movingaverage1,
                                        value
                                    }
                                }))
                        },
                        {
                            inputType: "Text",
                            className: "trade_inputs_movingaverage",
                            inputValue: movingaverage2,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    movingaverage2: {
                                        ...prev.movingaverage2,
                                        value
                                    }
                                }))
                        },
                        {
                            inputType: "Text",
                            className: "trade_inputs_movingaverage",
                            inputValue: movingaverage3,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    movingaverage3: {
                                        ...prev.movingaverage3,
                                        value
                                    }
                                }))
                        },
                        {
                            inputType: "Text",
                            className: "trade_inputs_movingaverage",
                            inputValue: movingaverage4,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    movingaverage4: {
                                        ...prev.movingaverage4,
                                        value
                                    }
                                }))
                        },
                        {
                            inputType: "Text",
                            className: "trade_inputs_movingaverage",
                            inputValue: movingaverage5,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    movingaverage5: {
                                        ...prev.movingaverage5,
                                        value
                                    }
                                }))
                        }
                    ]
                }
            ]
        },
        {
            headerName: "Wave Trend",
            FieldSet: [
                {
                    legend: "Moving Manrate",
                    classNames: {
                        legendClassName: " text-[#000]  block p-1 text-base",
                        fieldsetClassName:
                            "flex flex-wrap justify-around items-center primaryBorder rounded-sm"
                    },
                    styles: {
                        legendStyle: {},
                        fieldsetStyle: {}
                    },
                    FillDataInput: [
                        {
                            inputType: "Text",
                            className: "",
                            inputValue: manRateDown,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    manRateDown: {
                                        ...prev.manRateDown,
                                        value
                                    }
                                }))
                        },
                        {
                            inputType: "Text",
                            className: "",
                            inputValue: manRateUp,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    manRateUp: {
                                        ...prev.manRateUp,
                                        value
                                    }
                                }))
                        }
                    ]
                },
                {
                    legend: `Wave Level `,
                    classNames: {
                        legendClassName: " text-[#000]  block p-1 text-base",
                        fieldsetClassName:
                            "flex flex-wrap justify-around items-center primaryBorder rounded-sm"
                    },
                    styles: {
                        legendStyle: {},
                        fieldsetStyle: {}
                    },
                    FillDataInput: [
                        {
                            inputType: "Text",
                            className: "",
                            inputValue: sideWaveLevelBuy,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    sideWaveLevelBuy: {
                                        ...prev.sideWaveLevelBuy,
                                        value
                                    }
                                }))
                        },
                        {
                            inputType: "Text",
                            className: "",
                            inputValue: sideWaveLevelSell,
                            getValueFunc: (value) =>
                                setState((prev) => ({
                                    ...prev,
                                    sideWaveLevelSell: {
                                        ...prev.sideWaveLevelSell,
                                        value
                                    }
                                }))
                        }
                    ]
                }
            ]
        }
    ];

    function resetSettings() {
        setState((prev) => {
            return {
                ...prev,
                renkoSize: {
                    ...prev.renkoSize,
                    value: renkoPipes
                },
                timeFrame: {
                    ...prev.timeFrame,
                    value: timeFrameValue
                },
                // startTime: {
                //     ...prev.startTime,
                //     dbDate: renkoStartDate != "" ? moment(renkoStartDate).format() : moment().format(),
                //     value: renkoStartDate != "" ? moment(renkoStartDate) : moment(),
                //     placeholder: renkoStartDate != "" ? moment(renkoStartDate).format("DD/MM/YYYY") : 'Start Date'
                // },
                // slingShotFastCandle: {
                //     ...prev.slingShotFastCandle,
                //     value:
                // },
                // slingShotSlowCandle: {
                //     ...prev.slingShotSlowCandle,
                //     value: dataConfig.emavalueslow_candle
                // },
                slingShotFastRenko: {
                    ...prev.slingShotFastRenko,
                    value: emaValueFastRenko
                },
                slingShotSlowRenko: {
                    ...prev.slingShotSlowRenko,
                    value: emaValueSlowRenko
                },
                movingaverage1: {
                    ...prev.movingaverage1,
                    value: mastep1
                },
                movingaverage2: {
                    ...prev.movingaverage2,
                    value: mastep2
                },
                movingaverage3: {
                    ...prev.movingaverage3,
                    value: mastep3
                },
                movingaverage4: {
                    ...prev.movingaverage4,
                    value: mastep4
                },
                movingaverage5: {
                    ...prev.movingaverage5,
                    value: mastep5
                },
                manRateDown: {
                    ...prev.manRateDown,
                    value: waveEma1
                },
                manRateUp: {
                    ...prev.manRateUp,
                    value: waveEma2
                },
                sideWaveLevelBuy: {
                    ...prev.sideWaveLevelBuy,
                    value: buyWave
                },
                sideWaveLevelSell: {
                    ...prev.sideWaveLevelSell,
                    value: sellWave
                },

                // renkoNumber: {
                //     ...prev.renkoNumber,
                //     value: dataConfig.renko_test_batch
                // },
                distanceMoving: {
                    ...prev.distanceMoving,
                    value: distance_moving
                },
                upperBRP: {
                    ...prev.upperBRP,
                    value: upperBoundRangePercentage
                },
                lowerBRP: {
                    ...prev.lowerBRP,
                    value: lowerBoundRangePercentage
                },
                startRenko: {
                    ...prev.startRenko,
                    value: startRenkoValue
                },
                strategy: {
                    ...prev.strategy,
                    placeholder: strategies[strategyType ? strategyType : 1].strategy_desc,
                    value: strategyType
                }
            };
        });
    }
    useEffect(() => {
        dispatch(getChartSettingsAction());
    }, [currentSide.side, currentCurrencyId, currentSide.value]);

    useEffect(() => {
        resetSettings();
    }, [spinnerStatus]);
    return (
        <div className="w-full px-2 max-w-4xl self-center">
            {spinnerStatus ? (
                <Spinner
                    toggleValue={spinnerStatus}
                    props={{
                        parentDiv: {
                            style: { zIndex: 100 },
                            className: "loader"
                        },
                        spinnerIcon: {
                            style: {},
                            className: "loader-icon"
                        }
                    }}
                />
            ) : null}
            <TradeBoxes
                headerName={<MainBoxHeader />}
                classNames={{
                    parentDiv: `flex flex-col  rounded-2xl mt-3  ${
                        isDarkMode ? "bg-tertiaryDark " : "bg-tertiaryLight "
                    }`,
                    header: `flex justify-center  w-full h-1/2 ${
                        isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight "
                    } secondaryBoder rounded-tl-2xl rounded-tr-2xl roundedt items-center p-2`,
                    content: `flex flex-col justify-center p-2 secondaryBoder  rounded-bl-2xl rounded-br-2xl ${
                        isDarkMode ? "text-white" : "text-[#000] "
                    }`
                }}
                styles={{
                    parentDiv: {},
                    header: {},
                    content: {}
                }}>
                {inputsSection.map((tradebox, index) => {
                    const { headerName, FieldSet } = tradebox;
                    return (
                        <TradeBoxes
                            key={index}
                            headerName={headerName}
                            icon={""}
                            classNames={{
                                parentDiv: "trade_box   ",
                                header: `flex w-full h-1/2 ${
                                    isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                                } secondaryBoder rounded-tl-2xl rounded-tr-2xl roundedt items-center p-2`,
                                content:
                                    "flex flex-col justify-center p-2 secondaryBoder rounded-bl-2xl rounded-br-2xl"
                            }}
                            styles={{
                                parentDiv: {},
                                header: {},
                                content: {}
                            }}>
                            {FieldSet.map((fieldset, index) => {
                                const { FillDataInput, legend, styles, classNames } = fieldset;
                                return (
                                    <FieldSetComponent
                                        classNames={classNames}
                                        key={index}
                                        legend={legend}
                                        styles={styles}>
                                        {FillDataInput.map((fieldinput, index) => {
                                            const {
                                                getValueFunc,
                                                inputValue,
                                                className,
                                                inputType,
                                                optionsList,
                                                optionName,
                                                defaultText
                                            } = fieldinput;
                                            return (
                                                <FillDataInputComponent
                                                    inputType={inputType}
                                                    key={index}
                                                    className={className}
                                                    inputValue={inputValue}
                                                    getValueFunc={getValueFunc}
                                                    optionsList={optionsList}
                                                    optionName={optionName}
                                                    defaultText={defaultText}
                                                    isDarkMode={isDarkMode}
                                                />
                                            );
                                        })}
                                    </FieldSetComponent>
                                );
                            })}
                        </TradeBoxes>
                    );
                })}
                <TradeBoxes
                    height="auto"
                    headerName="update defaults"
                    classNames={{
                        parentDiv: "flex flex-col bg-white rounded-2xl mt-3 ",
                        header: `flex w-full h-1/2 ${
                            isDarkMode ? "bg-secondaryDark" : "bg-secondaryLight"
                        } secondaryBoder rounded-tl-2xl rounded-tr-2xl roundedt items-center p-2`,
                        content:
                            "flex flex-col justify-center p-2 secondaryBoder rounded-bl-2xl rounded-br-2xl"
                    }}
                    styles={{
                        parentDiv: {},
                        header: {},
                        content: {}
                    }}>
                    <StartStopbtn
                        positiveFunc={() => dispatch(updateSettingsAction(updatedValuesObject))}
                        negativeFunc={() => toggleModal((prev) => (prev = !prev))}
                        padding="0 20px"
                        negativeText="cancel"
                        positiveText="apply changes"
                        parentDivClassName={"w-full flex justify-around "}
                        // positiveActive={isModelActive}
                        negativeActive={false}
                        positiveClassName="bg-secondaryGreen text-white p-1 my-1 rounded-sm min-w-18 py-2 w-20"
                        negativeClassName="bg-secondaryRed text-white p-1 my-1 rounded-sm min-w-18 py-2 w-20"
                        // positiveFunc={() => startManualOrder()}
                        // negativeFunc={() => stopManualOrder()}
                    />
                </TradeBoxes>
            </TradeBoxes>
            <ToastContainer />
        </div>
    );
}
